<template>
  <div
    id="drop-area"
    @dragover.prevent
    @drop.prevent="handleDrop"
    style="border: 2px dashed #888; padding: 40px; text-align: center; border-radius: 12px"
  >
    <p>Drag and drop files here or <input type="file" multiple @change="handleFileSelect" style="display: inline" /></p>
    <ul>
      <li v-for="f in uploadedFiles" :key="f.key">{{ f.name }} — Uploaded!</li>
    </ul>
    <p v-if="uploading">Uploading...</p>
  </div>
</template>

<script>
import api from '@/assets/api'
export default {
  name: 'S3FileUploader',
  data() {
    return {
      uploading: false,
      uploadedFiles: [],
    }
  },
  methods: {
    handleDrop(e) {
      const files = e.dataTransfer.files
      this.uploadFiles(files)
    },
    handleFileSelect(e) {
      const files = e.target.files
      this.uploadFiles(files)
    },
    async uploadFiles(fileList) {
      this.uploading = true
      for (let file of fileList) {
        try {
          // 1. Get presigned URL from Lambda
          const res = await api.apiFetch('/uploadfile', {
            method: 'POST',
            //headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              fileName: file.name,
              fileType: file.type,
            }),
          })
          const ress = await res.json()
          const { url, key } = ress

          // 2. PUT file to S3
          await fetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': file.type,
            },
            body: file,
          })

          this.uploadedFiles.push({ name: file.name, key })
        } catch (err) {
          alert(`Upload failed for ${file.name}`)
        }
      }
      this.uploading = false
    },
  },
}
</script>
